import {useState} from 'react'
import {useDispatch} from 'react-redux'
import {Link, useNavigate} from 'react-router-dom'
import {useFormik} from 'formik'
import {
  BOOKING_LIST,
  COMPLAINTS_LIST,
  DASHBOARD,
  FORGOT_PASSWORD,
  // REGISTER
} from 'router/routes'
import AuthWrapper from 'components/auth/wrapper'
import {updateAuth} from 'store/actions/auth'
import {loginValidate, getRoles} from 'services/api/actions'
import {loginSchema as validationSchema} from 'utils/validations'
import {parseError} from 'utils'
import configs from 'configs'
import Input from 'components/shared/form/input'
import AlertBar from 'components/shared/alertBar'
import Button from 'components/shared/buttons'
import FormHeader from 'components/auth/formHeader'
import {INPUT_TYPES, USER_TYPES_ROLE_ID} from 'constants'
// import Select from 'components/shared/form/select'
// import {useSelector} from 'react-redux'
import {updateRoles} from 'store/actions/configs'
import {toast} from 'react-toastify'
import {is_technician ,is_vendor } from 'helpers/userRoles'

const initialValues = {
  email: '',
  password: '',
  // society_id: '',
}

const Login = () => {
  // const societies = useSelector((state) => state.configs.societies)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)

  const getRolesList = () => {
    getRoles()
      .then((response) => {
        dispatch(updateRoles(response.data))
      })
      .catch((error) => toast.error(parseError(error)))
  }


  const onSubmit = async (values, {setStatus}) => {
    setLoading(true)
    // values.society_id = parseInt(values.society_id || 0)
    loginValidate(values)
      .then((response) => {
        setLoading(false)
  
        const { resident, guard, vendor } = USER_TYPES_ROLE_ID
        if ([resident, guard].includes(response.data.role_id))
          return setStatus('Invalid email or password. Please try again.')
  
        dispatch(updateAuth(response.data))
        getRolesList()
  
        // Check user role and navigate accordingly
        if (is_technician(response.data)) {
          navigate(COMPLAINTS_LIST)
        } else if (is_vendor(response.data)) {
          navigate(BOOKING_LIST)
        } else {
          navigate(DASHBOARD)
        }
      })
      .catch((error) => {
        setLoading(false)
        setStatus(parseError(error))
      })
  }

  const {getFieldProps, handleSubmit, touched, errors, status} = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  })

  return (
    <AuthWrapper>
      <form className='form w-100' onSubmit={handleSubmit} noValidate>
        <FormHeader
          title={`Sign In to ${configs.appTitle}`}
          // subTitle='New Here?'
          // link={{label: 'Create an Account', to: REGISTER}}
        />

        <AlertBar message={status} />

        <div className='fv-row mb-10'>
          <Input
            label='Email'
            placeholder='Email'
            type={INPUT_TYPES.email}
            touched={!!touched.email}
            error={errors.email || ''}
            {...getFieldProps('email')}
          />
        </div>

        <div className='fv-row mb-10'>
          <div className='d-flex justify-content-between mt-n5'>
            <div className='d-flex flex-stack mb-2'>
              <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>
              {/* <Link
                to={FORGOT_PASSWORD}
                className='link-primary fs-6 fw-bolder'
                style={{marginLeft: '5px'}}
              >
                Forgot Password ?
              </Link> */}
            </div>
          </div>

          <Input
            placeholder='Password'
            type={INPUT_TYPES.password}
            touched={!!touched.password}
            error={errors.password || ''}
            {...getFieldProps('password')}
          />
        </div>

        {/* <div className='fv-row mb-10'>
          <Select
            label='Society'
            options={societies}
            touched={!!touched.society_id}
            error={errors.society_id || ''}
            labelField='society_name'
            {...getFieldProps('society_id')}
          />
        </div> */}

        <div className='text-center'>
          <Button className='w-100 mb-5' loading={loading} disabled={loading} label='Sign In' />
        </div>

        <div style={{textAlign: 'center'}}>
          <Link to={FORGOT_PASSWORD} className='link-primary fs-6 fw-bolder'>
            Forgot Password ?
          </Link>
        </div>
      </form>
    </AuthWrapper>
  )
}

export default Login
